import React from 'react'

import {Alert, Button, Modal, ModalHeader, ModalActions} from '../UI/index.js'
import Address from './Address.js'
import {formSpacing, FormStack, Select, Toggle} from '../UI/forms/index.js'
import NewAddress from './NewAddress.js'
import t from 'src/helpers/Languages.js'
import {getAvailableBranches} from 'src/utils/branches.js'
import {validateTimeslot} from '@utils/timeslot.js'

export default class AddressModal extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            address: NewAddress(),
            modalIsOpen: false,
            loading: false,
            error: '',
            onSave: undefined,
            onRemove: undefined
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(address, onSave, onRemove) {
        this.setState({
            modalIsOpen: true,
            address: address || this.state.address,
            onSave,
            onRemove
        })
    }

    close() {
        this.setState(this.initialState)
    }

    onSubmit(event) {
        event.preventDefault()
        const {address, onSave} = this.state
        const {showTimeslot} = this.props

        const timeslotError = showTimeslot && validateTimeslot(address)

        if (timeslotError) {
            this.setState({error: t(timeslotError)})
            return
        }

        if (this.address.validate()) {
            this.setState({loading: true, error: ''})

            if (onSave && typeof onSave === 'function') {
                onSave(address)
            }
        }
    }

    onClickRemove() {
        const {onRemove} = this.state

        this.setState({loading: true, error: ''})
        onRemove()
    }

    setError(error) {
        this.setState({error, loading: false})
    }

    response(err) {
        if (err) {
            this.setState({loading: false, error: err})
        } else {
            this.close()
        }
    }

    onAddressChange(address) {
        this.setState({address})
    }

    render() {
        const {address, modalIsOpen, error, loading, onRemove} = this.state
        const {showEmail = true, showPhone = true, showBusinessCheckbox = true, noTAV = false, showInstructions = false, showTimeslot = false, allowEmptyName, reseller} = this.props

        return (
            <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                <ModalHeader title={address._id ? t('editAddress') : t('newAddress')} onClose={this.close.bind(this)} style={{marginBottom: 0}} />

                <form onSubmit={this.onSubmit.bind(this)}>
                    <FormStack style={{marginBottom: formSpacing.section}}>
                        {getAvailableBranches(reseller).length > 0 &&
                            <Select
                                style={{marginTop: 12, width: '50%'}}
                                label={t('branch')}
                                value={address.branchId || ''}
                                options={getAvailableBranches(reseller).map((branch) => {
                                    return {value: branch.id, title: branch.name}
                                })}
                                onChange={(event) => this.onAddressChange({...address, branchId: event.target.value})}
                                allowEmpty
                            />
                        }

                        <Address
                            email={showEmail}
                            phone={showPhone}
                            businessCheckbox={showBusinessCheckbox}
                            overridePosition={true}
                            state={true}
                            noTAV={noTAV}
                            showInstructions={showInstructions}
                            showTimeslot={showTimeslot}
                            allowEmptyName={allowEmptyName}
                            address={address}
                            onChange={this.onAddressChange.bind(this)}
                            allowAttachments={true}
                            ref={(ref) => this.address = ref}
                        />

                        {/* TODO: remove this after Px pilot */ this.props.showPx &&
                            <Toggle
                                style={{marginTop: 24, width: '50%'}}
                                label={t('sendWithPxByDefault')}
                                checked={address.px}
                                onChange={(event) => this.onAddressChange({...address, px: event.target.checked})}
                            />
                        }
                    </FormStack>

                    {error &&
                        <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                    }

                    <ModalActions style={{marginTop: 12}}>
                        {onRemove && typeof onRemove === 'function' &&
                            <Button variant='error' onClick={this.onClickRemove.bind(this)} loading={loading}>{t('delete')}</Button>
                        }
                        <Button type='submit' loading={loading}>{t('save')}</Button>
                    </ModalActions>
                </form>
            </Modal>
        )
    }
}
